(function (jQuery, Drupal) {

  var once = true;
  Drupal.behaviors.masonry = {
    attach: function (context, settings) {
      if (once) {
        once = false;

        jQuery('body.page-node-type-page-front article.node--type-page-front .view-inspirations .view-content').masonry({
          itemSelector: '.views-row',
          columnWidth: 270,
          gutter: 16
        });

        jQuery('body.page-node-type-page-consumers article.node--type-page-consumers .view-inspirations .view-content').masonry({
          itemSelector: '.views-row',
          columnWidth: 270,
          gutter: 16
        });
      }
    }
  };

})(jQuery, Drupal);
